import { render, staticRenderFns } from "./RoleCreateUpdate.vue?vue&type=template&id=c830a74c&scoped=true&"
import script from "./RoleCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./RoleCreateUpdate.vue?vue&type=script&lang=js&"
import style0 from "./RoleCreateUpdate.vue?vue&type=style&index=0&id=c830a74c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c830a74c",
  null
  
)

export default component.exports